<p>user-guide works!</p>

{{path}}
  <!-- HOW TO INJECT A FILE HERE -->
  <div [innerHTML]="eulaContent">...</div>

 